import React from 'react'
import SignatureCollectionContent from './../components/SignatureCollection/SignatureCollectionContent';



const SignatureCollection = (props) => {


  return (
    <>
        <SignatureCollectionContent following = {props.following === true ? true : false}/>
    </>
  )
}

export default SignatureCollection